<template>
  <tr>
    <td class="c-table__cell--left c-table__cell--middle">{{ deliverDate }}<br />{{ deliverTime }}</td>
    <td class="c-table__cell--center c-table__cell--middle">{{ abtestInfo.abtestTypes[abtest.abtest_type] }}</td>
    <td class="c-table__cell--left c-table__cell--middle">
      <p class="u-w310 u-text-ellipsis">{{ abtest.abtest_name }}</p>
    </td>
    <td v-if="abtest.abtest_status != 2" class="c-table__cell--center c-table__cell--middle">
      {{ abtestInfo.abtestStatuses[abtest.abtest_status] }}
    </td>
    <td v-if="abtest.abtest_status == 2" class="c-table__cell--center c-table__cell--middle is-next">
      <div class="c-text"><a :href="'/coins-admin/abtest/result?abtest_id=' + abtest.abtest_id">テスト結果を見る</a></div>
    </td>

    <td class="c-table__cell--center c-table__cell--middle">
      <ul class="c-table-editable-list">

        <li v-if="abtest.abtest_status == 1" class="c-table-editable-list__item">
          <a class="c-btn c-btn--gray-3 c-btn--circle" @click="onStopClick">
            <div class="c-btn__text c-btn__text--balloon">停止する</div>
            <div class="c-icon c-icon--gray-3 u-wh20" style="width: 27px !important; height: 27px !important;"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#stop" />
            </svg>
            </div>
          </a>
        </li>

        <li v-if="abtest.abtest_status != 2" class="c-table-editable-list__item">
          <a class="c-btn c-btn--gray-3 c-btn--circle" @click="onEditClick">
            <div class="c-btn__text c-btn__text--balloon">編集する</div>
            <div class="c-icon c-icon--gray-3 u-wh20"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
            </div>
          </a>
        </li>
        <li class="c-table-editable-list__item">
          <a class="c-btn c-btn--gray-3 c-btn--circle" @click="onDeleteClick">
            <div class="c-btn__text c-btn__text--balloon">削除する</div>
            <div class="c-icon c-icon--gray-3 u-wh20"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#trash" />
            </svg>
            </div>
          </a>
        </li>
      </ul>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    abtest: Object,
    abtestInfo: Object,
  },
  emits: ["delete-click","stop-click","copy-click","edit-click"],
  computed: {
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
    deliverDate: function() {
      let deliverDate = '';
      let message = this.messageA;
      if(message && message.message_deliver){
        deliverDate = this.getDisplayDate(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
    deliverTime: function() {
      let deliverDate = '';
      let message = this.messageA;
      if(message && message.message_deliver){
        deliverDate = this.getDisplayTime(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
  },
  methods: {
    onDeleteClick: function () {
      this.$emit('delete-click', this.abtest);
    },
    onStopClick: function () {
      this.$emit('stop-click', this.abtest);
    },
    onCopyClick: function () {
      this.$emit('copy-click', this.abtest.abtest_id);
    },
    onEditClick: function () {
      this.$emit('edit-click', this.abtest.abtest_id);
    },
  },
};
</script>
